import type {
    CodeFontFamilyPlatform,
    CodeViewerLineState,
    TokenType
} from "./type";

export const CODE_TOKEN_TONES: Record<TokenType, keyof NCoreUIKit.CodeColorPalette> = {
    punctuationTag: "punctuationTag",
    punctuation: "punctuation",
    keywordControl: "keyword",
    component: "function",
    function: "function",
    operator: "default",
    property: "default",
    variable: "default",
    comment: "comment",
    htmlTag: "keyword",
    keyword: "keyword",
    arrow: "keyword",
    number: "string",
    string: "string",
    text: "default"
};

export const CODE_LANGUAGE_LABELS: Record<string, string> = {
    javascript: "JavaScript",
    typescript: "TypeScript",
    markdown: "Markdown",
    jsx: "JavaScript",
    tsx: "TypeScript",
    js: "JavaScript",
    python: "Python",
    ts: "TypeScript",
    md: "Markdown",
    shell: "Shell",
    bash: "Shell",
    csharp: "C#",
    html: "HTML",
    json: "JSON",
    py: "Python",
    yaml: "YAML",
    zsh: "Shell",
    sh: "Shell",
    yml: "YAML",
    css: "CSS",
    sql: "SQL",
    xml: "XML",
    cs: "C#"
};

export const CODE_FONT_FAMILIES: Record<CodeFontFamilyPlatform, string> = {
    web: "ui-monospace, \"SF Mono\", Menlo, Consolas, \"Liberation Mono\", monospace",
    android: "monospace",
    default: "monospace",
    ios: "Menlo"
};

export const CODE_FOLD_CLOSING_PATTERN = /^(?:[}\])]|\/?>|<\/)/;

export const CODE_EDITOR_ENCODING = "UTF-8";

export const CODE_MONO_ADVANCE = 0.6;

export const CODE_LINE_SIGNS: Record<CodeViewerLineState, string> = {
    removed: "\u2212",
    highlighted: "",
    added: "+"
};
